import { Div, Ref } from "@tblabs/truffle";
import { InfoBox } from "./InfoBox";
import { Loader } from "../../Components/Utils/Loader";


export class Page extends Div
{
    public body: Div;
    private loader = new Loader("Ładowanie strony...");

    constructor(private pageTitle: string, cssClasses: string = "")
    {
        super(cssClasses);

        this.SetTitle(this.pageTitle);

        this.body = new Div("");

        this.Append(
            new Div("content")
                .Append(this.body),
        );
    }

    protected SetTitle(title: string | Ref<string>)
    {
        document.title = title instanceof Ref ? title.value : title || "specTeam.pl";
    }

    public async Content(content: (body: Div) => Promise<void>): Promise<void>
    {
        try
        {
            this.Append(this.loader);

            await content(this.body);
        }
        catch (ex: any)
        {
            console.error(ex);

            let messageHeader = "Error";
            let messageBody = ex.message;
            const msg = ex.message.toLowerCase();

            if (msg.includes("unauthorized"))
            {
                messageHeader = "Unauthorized";
                messageBody = "You are not supposed to be here...";
            }
            else if (msg.includes("failed to fetch"))
            {
                messageHeader = "Connection problem";
                messageBody = "Check your connection and try again";
            }

            this.body.Append(
                new InfoBox(messageHeader, messageBody),
            );
        }
        finally
        {
            this.loader.RemoveSelf();
        }
    }
}

export class AdminPage extends Div
{
    public body: Div;
    private loader = new Loader("Ładowanie strony...");

    constructor(private pageTitle: string, cssClasses: string = "")
    {
        super("admin-page " + cssClasses);

        this.SetTitle(this.pageTitle);

        this.body = new Div("");

        this.Append(
            new Div("content")
                .Append(this.body),
        );
    }

    protected SetTitle(title: string | Ref<string>)
    {
        document.title = title instanceof Ref ? title.value : title || "specTeam.pl";
    }

    public async Content(content: (body: Div) => Promise<void>): Promise<void>
    {
        try
        {
            this.Append(this.loader);

            await content(this.body);
        }
        catch (ex: any)
        {
            console.error(ex);

            let messageHeader = "Error";
            let messageBody = ex.message;
            const msg = ex.message.toLowerCase();

            if (msg.includes("unauthorized"))
            {
                messageHeader = "Unauthorized";
                messageBody = "You are not supposed to be here...";
            }
            else if (msg.includes("failed to fetch"))
            {
                messageHeader = "Connection problem";
                messageBody = "Check your connection and try again";
            }

            this.body.Append(
                new InfoBox(messageHeader, messageBody),
            );
        }
        finally
        {
            this.loader.RemoveSelf();
        }
    }
}
